import React from 'react';
import './Spinner.style.css';

const Spinner = () => {
  return (
    <div className='spinner-container'>
      <div className='loadingio-spinner-spinner-2by998twmg8'>
        <div className='ldio-yzaezf3dcmj'>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      {/* <div className='loading-text'>Loading...</div> */}
    </div>
  );
};

export default Spinner;
